import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface SettingsPageHeaderProps {
  /** Current page title (e.g. "Role Management") */
  title: string;
  /** Settings link path - defaults to /settings or /nursery/:id/settings */
  settingsPath: string;
  /** Optional action buttons (e.g. Add Role, Add User) */
  action?: React.ReactNode;
}

const SettingsPageHeader: React.FC<SettingsPageHeaderProps> = ({ title, settingsPath, action }) => {
  const { t } = useTranslation('components', { keyPrefix: 'settingsPageHeader' });

  return (
    <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2">
      <div>
        <nav aria-label={t('breadcrumbLabel')}>
          <ol className="breadcrumb mb-1">
            <li className="breadcrumb-item">
              <Link to={settingsPath}>{t('settings')}</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">{title}</li>
          </ol>
        </nav>
        <h2 className="fw-bold ll-page-title mb-0">{title}</h2>
      </div>
      {action && (
        <div className="d-flex gap-2">
          {action}
        </div>
      )}
    </div>
  );
};

export default SettingsPageHeader;
